import { render, staticRenderFns } from "./CameraFaceId.vue?vue&type=template&id=28cd1070&scoped=true"
import script from "./CameraFaceId.vue?vue&type=script&lang=js"
export * from "./CameraFaceId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd1070",
  null
  
)

export default component.exports